import { isNZLocale } from 'lib/PropertyUtils';
import CircleIcon from '@mui/icons-material/Circle';

export const PROPERTY_TYPES = [
    { label: 'House', value: 'House' },
    { label: 'Land', value: 'Land' },
    { label: 'Unit', value: 'Unit' },
    { label: 'Farm', value: 'Farm' },
    { label: 'Flats', value: 'Flats' },
    { label: 'Community', value: 'Community' },
    { label: 'Commercial', value: 'Commercial' },
    { label: 'Storage Unit', value: 'Storage Unit' },
    { label: 'Business', value: 'Business' },
    { label: 'Other', value: 'Other' },
];

export const PROPERTY_TYPES_NZ = [
    { label: 'Residential', value: 'Residential' },
    { label: 'Forestry', value: 'Forestry' },
    { label: 'Commercial', value: 'Commercial' },
    { label: 'Horticulture', value: 'Horticulture' },
    { label: 'Industrial', value: 'Industrial' },
    { label: 'Pastoral', value: 'Pastoral' },
    { label: 'Mining', value: 'Mining' },
    { label: 'Utilities', value: 'Utilities' },
    { label: 'Lifestyle', value: 'Lifestyle' },
    { label: 'Specialist', value: 'Specialist' },
    { label: 'Arable', value: 'Arable' },
    { label: 'Other', value: 'Other' },
    { label: 'Dairying', value: 'Dairying' },
];

export const TEST_TYPES = Array.from({ length: 1000 }, (_, i) => ({
    label: `Property Type ${i + 1}`,
    value: `PropertyType${i + 1}`,
}));

export default isNZLocale() ? PROPERTY_TYPES_NZ : PROPERTY_TYPES;


export const VALUATION_CONFIDENCE = [
    { label: 'High Confidence', value: 'High', icon: <CircleIcon data-testid="colored-circle" style={{ color: '#39B54A', fontSize: '15px' }}/> },
    { label: 'Medium to High Confidence', value: 'Medium-High', icon: <CircleIcon data-testid="colored-circle" style={{ color: '#8ABA14', fontSize: '15px' }}/> },
    { label: 'Medium Confidence', value: 'Medium', icon: <CircleIcon data-testid="colored-circle" style={{ color: '#EFA000', fontSize: '15px' }}/> },
    { label: 'Low to Medium Confidence', value: 'Medium-Low', icon: <CircleIcon data-testid="colored-circle" style={{ color: '#F0763E', fontSize: '15px' }}/> },
    { label: 'Low Confidence', value: 'Low', icon: <CircleIcon data-testid="colored-circle" style={{ color: '#FF0F0F', fontSize: '15px' }}/> },
];